import React from 'react'
import { navigate } from 'gatsby'
import { useSetRecoilState } from 'recoil'
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js'
import { cartCountState, cartState } from '/src/hooks/useCart'
import { postRequest } from '/src/httpClient'

const initialOptions = {
  // 'client-id': 'AY52L8UOegOAB3Vmh7Cc16B6Ww9GinXI9t4o59a_xdRWnhjRrfI-l4vReH09XWrWbMQqBlsa23bVyLH2',
  'client-id': 'AdD4EwCtuKFaOx2kjZsjBT0zJJhW-lsYc89zUiApocvYvtz6-AWxJxXCDSvsWPbgwVNIfoCnRN8YPfkt',
  currency: 'AUD',
  intent: 'capture'
}

export const PaymentPayPalPaneForm = ({ cart }) => {
  const setCartState = useSetRecoilState(cartState)
  const setCartCountState = useSetRecoilState(cartCountState)

  return (
    <>
      <PayPalScriptProvider options={initialOptions}>
        <PayPalButtons
          createOrder={() => {
            return postRequest('/api/payment/paypal/create', {orderId: cart.id}).then(response => {
              return response.id
            })
          }}
          onApprove={(data, actions) => {
            return postRequest('/api/payment/paypal/approve', {
              orderId: cart.id,
              id: data.orderID,
              flow: 'mark'
            }).then(response => {
              // Passed approval, direct to checkout complete page.
              if (response && response.hasOwnProperty('redirectUrl')) {
                setCartState(false)
                setCartCountState(0)
                navigate(`/checkout/complete/${cart.id}`)
              }
            })
          }}
        />
      </PayPalScriptProvider>
    </>
  )
}

export default PaymentPayPalPaneForm
